import { apiCall, getConfig, serverUrl, axiosInstance } from "./Utils";
import type { ApiResult } from "../types/api";

const BASE = serverUrl + "/api/tracking";

export interface TrackEventDto {
    sessionId: string;
    userId: string;
    path: string;
    queryParams: Record<string, string>;
    userAgent: string;
}

export interface PageView {
    path: string;
    queryParams: Record<string, string>;
    timestamp: string;
    durationMs: number | null;
}

export interface UserSession {
    id: string;
    userId: string;
    sessionId: string;
    startedAt: string;
    lastActivityAt: string;
    userAgent: string;
    pages: PageView[];
}

async function track(event: TrackEventDto): Promise<ApiResult<void>> {
    return apiCall(axiosInstance.post(`${BASE}/track`, event, getConfig()));
}

async function getRecentSessions(limit = 100): Promise<ApiResult<UserSession[]>> {
    return apiCall(axiosInstance.get(`${BASE}/recent?limit=${limit}`, getConfig()));
}

async function getSessionsByUser(userId: string, limit = 50): Promise<ApiResult<UserSession[]>> {
    return apiCall(axiosInstance.get(`${BASE}/user/${userId}?limit=${limit}`, getConfig()));
}

async function getSession(sessionId: string): Promise<ApiResult<UserSession>> {
    return apiCall(axiosInstance.get(`${BASE}/session/${sessionId}`, getConfig()));
}

const ApiTrackingCtrl = {
    track,
    getRecentSessions,
    getSessionsByUser,
    getSession,
};

export default ApiTrackingCtrl;
